<template>
  <b-modal
    :id="modalId"
    :ref="modalId"
    :title="modalTitle"
    :ok-title="modalOkTitle"
    ok-only
    @ok="handleOk"
    data-cy="save"
    :size="modalSize"
  >
    <template #default>
      <rs-document-manager
        :add-file="addFile"
        :files="files"
        :show-principal-button="showPrincipalButton"
        :max-files="maxFiles"
        :required-file-type="requiredFileType"
        :accepted-file-extensions="acceptedFileExtensions"
        :required-approval-state="requiredApprovalState"
      />
    </template>
  </b-modal>
</template>
<script>
import { BModal } from 'bootstrap-vue';

import RsDocumentManager from '@/febos/global/customDocuments/components/repository-selector/RSDocumentManager';

export default {
  name: 'repository-selector',
  components: {
    BModal,
    RsDocumentManager,
  },
  props: {
    modalId: {
      type: String,
      default: 'add-repository-file',
    },
    modalTitle: {
      type: String,
      default: 'Adjuntar archivo desde el repositorio',
    },
    modalOkTitle: {
      type: String,
      default: 'Vale',
    },
    modalSize: {
      type: String,
      default: 'xl',
    },
    showPrincipalButton: {
      type: Boolean,
      default: false
    },
    addFile: {
      type: Function,
    },
    removeFile: {
      type: Function,
    },
    files: {
      type: Array,
      default: () => [],
    },
    maxFiles: {
      type: Number,
      default: 10,
    },
    requiredFileType: String,
    acceptedFileExtensions: String,
    requiredApprovalState: Number,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    handleOk() {},
  }
};
</script>
